export default __webpack_public_path__ + "static/media/Purina-logo.6b91e724.svg";